import { getSpecialOffers } from "@/api/specialOffers.api"

const initialState = () => ({
  baseApiUrl: window.PCE_CONFIG.baseApiUrl,
  dealer: window.PCE_CONFIG != null ? window.PCE_CONFIG.dealer : null,
  isModalOpen: false,
  showSpecialOffers: false,
  hasCheckedSpecialOffers: false
})

const state = initialState()

const getters = {
  dealer: state => {
    return state.dealer == null ? null : state.dealer
  },
  showStoreHours: state => {
    if (state.dealer?.storeHours == null) return;
    // if there's a single open time, we assume hours are supported
    return Object.entries(state.dealer.storeHours).find(h => h[1].open)
  },
  dealerStoreHours: state => {
    return state.dealer?.storeHours
  },
  dealerRating: state => {
    return state.dealer?.reviewStarRating
  },
  reviewCount: state => {
    return state.dealer?.reviewCount == null ? 0 : state.dealer.reviewCount
  },
  dealerName: state => {
    return state.dealer?.name
  },
  directionsLink: state => {
    return state.dealer?.directionsLink
  },
  dealerPhone: state => {
    return state.dealer?.phone
  },
  dealerTags: state => {
    return state.dealer?.tags
  },
  isModalOpen: state => {
    return state.isModalOpen
  },
  showSpecialOffers: state => {
    return state.showSpecialOffers
  }
}

const actions = {
  closeModal ({ commit }, value) {
    commit('CLOSE_MODAL', value)
  },
  toggleModal ({ commit }, value) {
    return new Promise((resolve, reject) => {
      if (!state.hasCheckedSpecialOffers) {
        getSpecialOffers(state.baseApiUrl, state.dealer.id).then(response => {
          var data = response.data;
          if (data != null && data.length > 0) {
            commit('SHOW_SPECIAL_OFFERS')
          }
          commit('SPECIAL_OFFERS_SHOWN')
          resolve()
        }, error => {
          reject(error)
        });
      }
      commit('TOGGLE_MODAL', value);
    })
  }
}

const mutations = {
  CLOSE_MODAL (state) {
    state.isModalOpen = false
  },
  TOGGLE_MODAL (state) {
    state.isModalOpen = !state.isModalOpen
  },
  SHOW_SPECIAL_OFFERS (state) {
    state.showSpecialOffers = true
  },
  SPECIAL_OFFERS_SHOWN (state) {
    state.hasCheckedSpecialOffers = true;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
